import React from 'react';
import { Grid } from '@material-ui/core';
import { func, string, bool } from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import styles from './Menu.module.scss';
import MenuItem from '../MenuItem';
import variables from '../../styles/variables.module.scss';
import HeadlineSmall from '../HeadlineSmall';
import DefaultParagraph from '../../typeface/DefaultParagraph';
import DefaultLink from '../../typeface/DefaultLink';
import { menu } from '../../data';

const Menu = ({ pathname, menuHidden, toggleMenu }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          contactMail
          businessMail
          careerMail
          menuLinks {
            name
            link
          }
        }
      }
    }
  `);
  const {
    menuLinks,
    contactMail,
    businessMail,
    careerMail,
  } = data.site.siteMetadata;

  const onMapClicked = () => {
    const win = window.open(
      'https://goo.gl/maps/2KQBuoNL638ATkSB9',
      '_blank'
    );
    win.focus();
  };

  return (
    <Grid
      container
      style={{ height: '100%' }}
      className={[
        styles.container,
        !menuHidden && styles.containerShow,
      ].join(' ')}
    >
      <Grid item xs={12} md={6}>
        <Grid container className={styles.containerLeft}>
          <Grid
            item
            xs={12}
            md={6}
            className={styles.containerUpperLeft}
          >
            <Grid
              container
              justify="space-between"
              className={styles.containerInnerSpecial}
            >
              <Grid
                item
                xs={12}
                className={styles.hiddenXS}
              >
                <HeadlineSmall
                  color={variables.carbonBlack}
                >
                  {menu.smallTextUpperLeft}
                </HeadlineSmall>
                <h4>{menu.titleUpperLeft}</h4>
              </Grid>
              <Grid
                item
                xs={12}
                className={styles.containerUpperLeftBottom}
              >
                <p className={styles.titleUpperLeftBottom}>
                  {menu.titleUpperLeftBottom}
                </p>
                <DefaultParagraph
                  xsmall
                  style={{ color: variables.carbonBlack }}
                >
                  {menu.textUpperLeftBottom}
                </DefaultParagraph>
                <DefaultLink
                  href={`mailto:${businessMail}`}
                  className={styles.menuLink}
                  color={variables.carbonBlack}
                >
                  <DefaultParagraph xsmall>
                    {businessMail}
                  </DefaultParagraph>
                </DefaultLink>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={styles.containerUpperRight}
            onClick={onMapClicked}
          >
            <HeadlineSmall
              className={styles.hiddenXS}
              color={variables.carbonBlack}
            >
              {menu.smallTextUpperRight}
            </HeadlineSmall>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={styles.containerLowerLeft}
          >
            <Grid
              container
              justify="space-between"
              className={styles.containerInnerSpecial}
            >
              <Grid
                item
                xs={12}
                className={styles.hiddenXS}
              >
                <HeadlineSmall>
                  {menu.smallTextLowerLeft}
                </HeadlineSmall>
                <h4>{menu.titleLowerLeftTop}</h4>
              </Grid>
              <Grid
                item
                xs={12}
                className={styles.containerLowerLeftBottom}
              >
                <p className={styles.titleLowerLeftBottom}>
                  {menu.titleLowerLeftBottom}
                </p>
                <div>
                  <DefaultParagraph xsmall>
                    {menu.smallTextLowerLeftBottom}
                  </DefaultParagraph>
                  <DefaultLink
                    href={`mailto:${contactMail}`}
                    className={styles.menuLink}
                    color={variables.cleanWhite}
                  >
                    <DefaultParagraph xsmall>
                      {contactMail}
                    </DefaultParagraph>
                  </DefaultLink>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            className={styles.containerLowerRight}
          >
            <Grid
              container
              justify="space-between"
              className={styles.containerInnerSpecial}
            >
              <Grid
                item
                xs={12}
                className={styles.hiddenXS}
              >
                <HeadlineSmall>
                  {menu.smallTextLowerRight}
                </HeadlineSmall>
                <h4>{menu.titleLowerRightTop}</h4>
              </Grid>
              <Grid
                item
                xs={12}
                className={styles.containerLowerRightBottom}
              >
                <p className={styles.titleLowerRight}>
                  {menu.titleLowerRightBottom}
                </p>
                <DefaultLink
                  href={`mailto:${careerMail}`}
                  className={styles.menuLink}
                  color={variables.cleanWhite}
                >
                  <DefaultParagraph xsmall>
                    {careerMail}
                  </DefaultParagraph>
                </DefaultLink>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid
          container
          justify="center"
          alignItems="center"
          direction="column"
          className={styles.containerRight}
        >
          <Grid item>
            {menuLinks.map((item, index) => (
              <MenuItem
                key={item.link}
                num={index + 1}
                title={item.name}
                to={item.link}
                toggleMenu={toggleMenu}
                active={
                  pathname === item.link ||
                  (index !== 0 &&
                    pathname.includes(item.link))
                }
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Menu.propTypes = {
  toggleMenu: func.isRequired,
  pathname: string.isRequired,
  menuHidden: bool,
};

Menu.defaultProps = {
  menuHidden: false,
};

export default Menu;
